import styles from './hair.module.scss';
import Card from 'src/components/Card/Card';
import Image from 'next/image';

export type HairDoctorCardProps = {
    data: {
        card: {
            name: string;
            image: {
                src: string;
                alt: string;
                width: number;
                height: number;
            };
            subtitle?: string;
            specialty: string;
            description: string;
            degree?: string;
        };
        className?: string;
        custom: {
            image: {
                src: string;
                alt: string;
                width: number;
                height: number;
            };
        };
    };
};

const HairDoctorCard = ({ data }: HairDoctorCardProps) => {
    return (
        <div className={`${styles['doctor-card']} ${data.className}`}>
            <div className="md:hidden">
                <div
                    className={`${styles['card-mobile']} mb-4 bg-white p-6 text-center`}
                >
                    <div className={`${styles['doctor-thumbnail']}`}>
                        <Image
                            src={data.custom.image.src}
                            alt={data.custom.image.alt}
                            width={data.custom.image.width}
                            height={data.custom.image.height}
                        />
                    </div>
                    <div className="mb-4">
                        {data.card.name}
                        {data.card.degree ? `, ${data.card.degree}` : ''}
                    </div>
                    <p>&qout;{data.card.description}&qout;</p>
                </div>
            </div>
            <div className="hidden md:block">
                <Card
                    name={data.card.name}
                    image={data.card.image}
                    subtitle={data.card.subtitle}
                    specialty={data.card.specialty}
                />
                <p className={`${styles['doctor-quote']}`}>
                    &qout;{data.card.description}&qout;
                </p>
            </div>
        </div>
    );
};

export default HairDoctorCard;
